import { useDispatch, useSelector } from "react-redux";
import buoy from "../../static/icons/buoy.png"
import { removeBuoy } from "../../redux/breakSlice";

function BuoyCard(props) {
    const selected = useSelector(state => state.breaks.form.selectedStations)
    const dispatch = useDispatch();

    const handleRemove = (id) => {
        let newList = selected.filter(buoy => buoy.id !== id);
        console.log(newList)
        dispatch(removeBuoy(newList));
    }

    return(
        <div className="bg-white m-3 pb-3 rounded-lg shadow-xl rounded zoom border-b-2" onClick={() => handleRemove(props.id)}>
            <div className="flex flex-row items-center mb-3 bg-gray-100 w-full p-4 rounded-t shadow-md">
                <img src={buoy} alt="buoy-icon" className="h-10"/>
                <div className="text-left ml-4 pr-8">
                    <h3 className="">{props.name}</h3>
                    <h3 className="">{props.id}</h3>
                </div>  
            </div>
            <p className="m-1 px-4">Station ID: {props.id}</p>
            <p className="m-1 px-4">Latitude: {props.lat}</p>
            <p className="m-1 px-4">Longitude: {props.lon}</p>
            {props.owner ? <p className="m-1 px-4">Owner: {props.owner}</p> : ""}
        </div>
    )
}

export default BuoyCard;